export default __webpack_public_path__ + "static/media/roadmap6.45f737fa.png";